export const RCA_PATIENT_LIST_LIMIT = 20

export enum RCAPatientListTabKeys {
	MY_PATIENTS_RCA = "MY_PATIENTS_RCA",
	MY_TEAM_PATIENTS_RCA = "MY_TEAM_PATIENTS_RCA",
	CALL_CONNECT_METRICS = "CALL_CONNECT_METRICS",
	METABASE_DASHBOARDS = "METABASE_DASHBOARDS",
}
